/* eslint-disable no-underscore-dangle */
/* eslint-disable arrow-body-style */
/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { selectAuth } from '@/store/selectors';
import { setAlert } from '@/store/slices/alert';
import { closeModal } from '@/store/slices/modal';
import { handleApiError } from '@/utils/helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

const fetcher = (url: any, customer: any) => {
  const response = axios({
    method: 'post',
    url: `https://${url}/api/resource/Customer`,
    data: customer,
    withCredentials: true,
  })
    .then((data) => data)
    .catch((error) => error);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useCreateCustomer = () => {
  const { url } = useSelector(selectAuth);
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleSuccess = () => {
    dispatch(
      setAlert({ type: 'success', message: 'Customer created successfully' }),
    );

    dispatch(closeModal({ type: 'createCustomer' }));
  };

  const handleError = (message: string) => {
    dispatch(setAlert({ type: 'error', message }));
  };

  const mutate = useMutation((customer: any) => fetcher(url, customer), {
    onSettled: (data) => {
      if (!data.data) {
        const errorMessage = handleApiError(data);
        handleError(errorMessage);
      } else if (data.data) {
        handleSuccess();
        queryClient.invalidateQueries(['customers']);
      }
    },
    onError: () => handleError('An Error Occured. Contact Administration'),
  });

  return mutate;
};
